import { Icons } from '@dbrain/ui';
import { useTranslation } from 'react-i18next';
import { useMicrosoft365Status } from '../../api/microsoft365.js';

/**
 * "Microsoft 365 bağlı" in the conversation's bar (MsTakvimYatay, MsMailListe): once this conversation used a
 * Microsoft 365 tool and the person's account is connected. Oppy's own line icon, never Microsoft's logo. Drawn
 * only once known and no taller than the bar's controls, so the bar never changes size (D-79).
 */
export function Microsoft365ConversationChip({ used }: { used: boolean }) {
  const { t } = useTranslation();
  const status = useMicrosoft365Status(used).data;
  if (!used || status?.state !== 'connected') return null;
  return (
    <span className="m365-chip" title={status.account ? t('microsoft365.user.chip.hint', { email: status.account.email }) : undefined} data-testid="microsoft365-chip">
      <Icons.connections size={14} />
      {t('microsoft365.user.chip.connected')}
    </span>
  );
}
